<template>
    <div class="wrap">
        <el-radio-group v-model="type" @change="changeType">
            <el-radio :label="1">通用配置</el-radio>
            <el-radio :label="2">按店铺配置</el-radio>
        </el-radio-group>
        <div class="mt-10">
            <div v-if="type === 1" class="flex">
                <el-select v-model="ruleId" placeholder="请选择" clearable width="200px">
                    <el-option v-for="item in goodsFissionRulesList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
                <div class="ml-5">
                    <span style="color:#333;">单店铺裂变链接数量</span>
                    <el-tooltip class="item" effect="dark" :content="`默认生成1个商品链接，单店铺单次最大可裂变${maxFissionNumber}个商品链接`" placement="top">
                        <i class="el-icon-question" style="color:#333;"></i>
                    </el-tooltip>
                    <el-input-digit v-model.number="fissionNumber" :placeholder="`裂变链接数量,输入上限为${maxFissionNumber}`" :max="maxFissionNumber" :precision="0" style="width: 170px" />
                </div>
            </div>
            <div v-else-if="type === 2"><el-link @click="dialogVisible = true">配置AI列表规则</el-link>（已配置店铺：<span>{{setShopRuleList.length}}</span>）</div>
        </div>
        <el-dialog
            title="编辑AI裂变规则"
            :visible.sync="dialogVisible"
            width="650px"
        >
            <div class="dialogCon">
                <div class="searchBox mb-10">
                    <el-select v-model="searchShop" class="mr-10" placeholder="铺货店铺" multiple clearable width="200px">
                        <el-option v-for="item in selectShops" :key="item.id" :label="item.shortTitle || item.title" :value="item.userId">
                            <div class="flex align-center">
                                <el-image style="height: 18px; margin-right:5px" :src="item.icon" v-if="item.icon"></el-image>
                                <span>{{item.shortTitle || item.title}}</span>
                            </div>
                        </el-option>
                    </el-select>
                    <el-button type="primary" @click="searchShopRule">查 询</el-button>
                </div>
                <div>
                    <div class="mb-10">
                        <el-select v-model="fillRuleId" class="mr-10" placeholder="请选择" clearable width="200px">
                            <el-option v-for="item in goodsFissionRulesList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                        <el-input-digit v-model.number="fillFissionNumber" class="mr-10" :placeholder="`裂变链接数量,输入上限为${maxFissionNumber}`" :max="maxFissionNumber" :precision="0" style="width: 180px" />
                        <el-button type="primary" @click="batchFill">批量填充</el-button>
                    </div>
                    <el-table
                        :data="filterList"
                        :highlight-current-row="true"
                        height="300px"
                        style="width: 100%"
                    >
                        <el-table-column type="index" width="50"></el-table-column>
                        <el-table-column prop="shop" label="店铺名称">
                            <div slot-scope="{row}" class="flex align-center">
                                <el-image style="height: 18px; margin-right:5px" :src="row.icon" v-if="row.icon"></el-image>
                                <span>{{row.shopName}}</span>
                            </div>
                        </el-table-column>
                        <el-table-column prop="rule" label="配置规则">
                            <template slot-scope="{row}">
                                <el-select v-model="row.ruleId" placeholder="请选择" clearable width="180px">
                                    <el-option v-for="item in goodsFissionRulesList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column prop="rule" label="裂变数量" width="130" :header-tooltip="`默认生成1个商品链接，单店铺单次最大可裂变${maxFissionNumber}个商品链接`">
                            <template slot-scope="{row}">
                                <el-input-digit v-model.number="row.fissionNumber" :placeholder="`输入上限为${maxFissionNumber}`" :max="maxFissionNumber" :precision="0" style="width: 100px" />
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
    props:{
        selectShops:{
            type:Array,
            default:()=>[]
        },
        fissionConfig:{
            type:Object,
            default(){
                return {}
            }
        }
    },
    data() {
        return {
            type: 1,
            ruleId:'',
            fissionNumber:1,
            dialogVisible: false,
            originShopRule:{},
            filterList:[],
            searchShop:[],
            fillRuleId:'',
            fillFissionNumber:''
        }
    },
    computed:{
        ...mapGetters(['goodsFissionRulesList','goodsFissionConfig']),
        setShopRuleList(){
            let list = Object.values(this.originShopRule);
            return list.filter(item => item.ruleId)
        },
        maxFissionNumber(){
            return this.goodsFissionConfig?.maxFissionNumber || 5
        }
    },
    watch:{
        fissionConfig:{
            handler(val){
                this.init(true);
            },
            deep:true,
            immediate:true
        },
        dialogVisible:{
            handler(v){
                if(v){
                    this.init(false,true)
                }
            },
            immediate:false
        }
        // selectShops:{
        //     handler(val){
        //         if(val){
        //             debugger
        //             this.searchShopRule()
        //         }
        //     },
        //     deep:true,
        //     immediate:false
        // },
    },
    methods:{
        ...mapActions(['getGoodsFissionRules']),
        searchShopRule(){
            let list = Object.values(this.originShopRule);
            if(this.searchShop.length){
                this.filterList = list.filter(item => this.searchShop.includes(item.userId))
            }else{
                this.filterList = list;
            }
        },
        batchFill(){
            if(!this.fillRuleId){
                this.$message.warning('请选择要填充的规则')
                return
            }
            this.filterList.forEach(item => {
                this.originShopRule[item.userId].ruleId = this.fillRuleId
                this.originShopRule[item.userId].fissionNumber = this.fillFissionNumber
            });
            this.searchShopRule();
        },
        getData(){
            let obj = {
                type:this.type,
                selectShops:this.selectShops
            };
            if(this.type === 1){
                obj.ruleId = this.ruleId
                obj.fissionNumber = this.fissionNumber
            }else if(this.type === 2){
                let map = {};
                this.setShopRuleList.forEach(item => {
                    map[item.userId] = item
                })
                obj.list = this.setShopRuleList
                obj.config = map
            }
            return obj
        },
        init(isFirst,isCache){
            if(!isCache){
                this.originShopRule = {};
            }
            this.searchShop = []
            this.fillRuleId = '';
            this.fillFissionNumber = '';
            // 初始化列表数据
            let initShopRule = {}
            let defaultType = null
            let defaultShopConfig = null
            if(Object.keys(this.fissionConfig).length){
                const { type,fissionRuleId,fissionNumber,shopConfig } = this.fissionConfig;
                defaultType = type
                defaultShopConfig = shopConfig
                if(isFirst){
                    this.type = type === 1 ? 2 : 1;
                }
                if(type === 0){
                    this.ruleId = fissionRuleId
                    this.fissionNumber = fissionNumber
                }
            }else{
                this.ruleId = ''
                this.fissionNumber = 1
            }
            this.selectShops.forEach(item => {
                let ruleId = ''
                let fissionNumber = 1
                if(defaultType === 1){
                    let _value = defaultShopConfig ? defaultShopConfig[item.id] : {}
                    if(typeof _value === 'object'){
                        ruleId = _value.fissionRuleId || ''
                        fissionNumber = _value.fissionNum || ''
                    }else{// 兼容历史数据
                        ruleId = defaultShopConfig ? defaultShopConfig[item.id] : ''
                    }
                }
                let obj = this.originShopRule[item.userId]
                initShopRule[item.userId] = obj ? obj : {
                    ruleId:ruleId,
                    fissionNumber:fissionNumber,
                    shopName:item.shortTitle || item.title,
                    id:item.shopId || item.id,
                    userId:item.userId,
                    icon:item.icon,
                };
            });
            this.originShopRule = initShopRule
            this.searchShopRule();
        },
        changeType(){
            this.init()
        }
    },
    created(){
        this.getGoodsFissionRules()
    },
    mounted(){
    }
}
</script>

<style lang="scss" scoped>
.searchBox{
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;
}
</style>